import "moment-timezone";

const TableChoiceDevices = (props) => {
    const typeStatus = {
        nn: "None",
        ok: "OK",
        al: "Alarm",
        nc: "Not Communicating",
        nf: "Not Defined",
    };

    const handleCheckboxChange = (id) => {
        if (props.devicesSel.includes(id)) {
            props.setDevicesSel(props.devicesSel.filter((deviceId) => deviceId !== id));
        } else {
            props.setDevicesSel([...props.devicesSel, id]);
        }
    };

    return (
        <table className="table table-striped">
            <thead>
                <tr>
                    <th></th>
                    <th key="name">UUID</th>
                    <th key="serial">Serial</th>
                    <th key="model">Modelo</th>
                    <th key="group">UID</th>
                    <th key="status">Estado</th>
                </tr>
            </thead>
            <tbody>
                {props.devices.map((item, index) => (
                    <tr key={index} data-idx={index}>
                        <td>
                            <input
                                type="checkbox"
                                name="checkboxContainer"
                                data-idx={item.id}
                                data-uuid={item.uuid}
                                checked={props.devicesSel.includes(item.id)}
                                onChange={() => handleCheckboxChange(item.id)}
                            />
                        </td>
                        <td>{item.uuid}</td>
                        <td>{item.serial}</td>
                        <td>{item.model_name}</td>
                        <td>{item.uid}</td>
                        <td>{item.status ? <span>{typeStatus[item.status]}</span> : <span>{typeStatus["nf"]}</span>}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableChoiceDevices;
